import { render, staticRenderFns } from "./PositionsShowMaturedTrades.vue?vue&type=template&id=c4680bb4&scoped=true"
import script from "./PositionsShowMaturedTrades.vue?vue&type=script&lang=js"
export * from "./PositionsShowMaturedTrades.vue?vue&type=script&lang=js"
import style0 from "./PositionsShowMaturedTrades.vue?vue&type=style&index=0&id=c4680bb4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4680bb4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VDataTable,VIcon,VRow,VSpacer})
